import { PageHeader } from "@justworkshr/milo-components";
import styles from "./CurrentInvoice.module.css";
import currentInvoice from "assets/sample_documents/sample_health_insurance_invoice.pdf";

const CurrentInvoice = (): JSX.Element => {
  return (
    <div className={styles.container}>
      <PageHeader
        title="What does this document contain?"
        className={styles.headerContainer}
      />
      <div className={styles.listItem}>
        An invoice should contain:
        <ul>
          <li>
            A list of all covered employees for the given billing period
            (typically a calendar month)
          </li>
          <li>
            Plan selection and tier for each employee for the billing period
          </li>
          <li>
            Total premium for the billing period for each covered employee
          </li>
        </ul>
      </div>
      <iframe
        title="current_invoice"
        src={currentInvoice}
        width="100%"
        height="500px"
      />
    </div>
  );
};
export default CurrentInvoice;
